<template>
  <g>
    <defs>
      <path
        d="M17.601,14.601 L6.401,14.601 C5.958,14.601 5.601,14.243 5.601,13.801 L5.601,9.376 L18.402,9.376 L18.402,13.801 C18.402,14.243 18.043,14.601 17.601,14.601 M6.401,6.601 L17.601,6.601 C18.043,6.601 18.402,6.959 18.402,7.4 L18.402,7.898 L5.601,7.898 L5.601,7.4 C5.601,6.959 5.958,6.601 6.401,6.601 M6.401,5 C5.075,5 4,6.075 4,7.4 L4,13.801 C4,15.127 5.075,16.202 6.401,16.202 L11.201,16.202 L11.201,18.4 L8.001,18.4 C7.559,18.4 7.201,18.758 7.201,19.2 C7.201,19.642 7.559,20 8.001,20 L16.001,20 C16.443,20 16.802,19.642 16.802,19.2 C16.802,18.758 16.443,18.4 16.001,18.4 L12.8,18.4 L12.8,16.202 L17.601,16.202 C18.927,16.202 20.001,15.127 20.001,13.801 L20.001,7.4 C20.001,6.075 18.927,5 17.601,5 L6.401,5 Z"
        id="display_grid"
      ></path>
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Desktop-HD" transform="translate(-210.000000, -270.000000)">
        <g id="Group" transform="translate(210.500000, 270.000000)">
          <rect
            id="Rectangle"
            fill-opacity="0.01"
            fill="#E3E3E3"
            style="mix-blend-mode: color-burn;"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <mask id="mask-2" fill="white">
            <use xlink:href="#display_grid"></use>
          </mask>
          <use id="Mask" :fill="currentColor" :opacity="opacity" xlink:href="#display_grid"></use>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>